<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'voucher.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Voucher <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                        <notice-published v-model="resource" label-published="Ce promo code est actif." label-unpublished="Ce promo code est inactif." :dates="true"></notice-published>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail du coupon</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <div class="selector" style="margin-bottom: 2em;">
                                  <label @click="selectIsGiftCard(false)" v-bind:class="{'active':!resource.is_giftcard}">
                                    <img :src="$iconFolder + 'product.svg'"/>
                                    <span>
                                        <strong>Bon d'achat promotionnel</strong>
                                        <p>Rabais en % ou en valeur</p>
                                    </span>
                                  </label>
                                  <label @click="selectIsGiftCard(true)" v-bind:class="{'active':resource.is_giftcard}">
                                    <img :src="$iconFolder + 'service.svg'"/>
                                    <span>
                                        <strong>Bon cadeau</strong>
                                        <p>Inclus un crédit à utiliser sur de multiples commandes</p>
                                    </span>
                                  </label>
                                </div>

                                <group-line-2 v-if="!resource.is_giftcard">

                                  <form-checklist :label="'Type de rabais'"
                                                  v-model="discountType"
                                                  :options="discountTypes"
                                                  :multiple="false"
                                                  :callback="selectDiscountType"></form-checklist>
                                  <form-text label="Valeur du bon d'achat" v-model="resource.value" :suffix="resource.is_number?$store.state.scope.currency_id:'%'" :required="true"></form-text>
                                </group-line-2>

                                <form-text v-if="resource.is_giftcard" label="Valeur du bon cadeau" v-model="resource.value" :suffix="$store.state.scope.currency_id" :required="true"></form-text>


                                <hr>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :lang="client.id" :translate-key="'name'" :translations="resource.translations" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :lang="client.id" :translate-key="'description'" :translations="resource.translations" :label="'Description'" v-model="resource.translations[client.id].description" :required="true"></form-text>
                                  </div>
                                </div>

                              </fieldset>
                            </tab>
                            <tab name="Codes à saisir">

                              <fieldset>
                                <h3>Codes de saisie</h3>
                                <p class="headline"></p>

                                <form-checklist :label="'Création des codes promo'"
                                                v-model="action"
                                                :options="actionsSource"
                                                :multiple="false"></form-checklist>

                                <div v-if="action == 'generator'">

                                  <group-line-3>
                                    <form-text label="Modèle de code à générer" placeholder='ABC-XXXX-XXXX' v-model="resource.mask" :required="true"></form-text>
                                    <form-text label="Quantité de codes à générer" v-model="tokenQuantity" :required="true"></form-text>
                                    <div style="align-self: self-end;margin-bottom: 1.875rem;"><button class="btn" @click="generateCodes()"><span>Générer les codes</span></button></div>
                                  </group-line-3>


                                </div>
                                <div v-else>
                                  <form-text label="Codes promo" v-model="token" :on-key-enter="addToken" hint="Vous pouvez saisir plusieurs codes, séparés par une virgule."></form-text>
                                  <button class="btn" @click="addToken(token)"><span>Ajouter les codes</span></button>
                                </div>

                                <div v-if="resource.tokens">
                                  <div>Total des codes promos: {{ resource.tokens.length }}</div>
                                  <div style="display: flex; flex-wrap: wrap; max-height: 200px; overflow-y: auto; margin-top: 10px;">
                                    <div v-for="(item, index) in resource.tokens" style="font-family: 'Courier New';font-weight: bold;padding: 5px; padding-left: 10px;border: 1px solid #000000; background: #111111; color: #fff; letter-spacing: 1px; margin-right: 8px; margin-bottom: 8px; border-radius: 6px; display: flex; align-items: center;">
                                      <span>{{ item }}</span>
                                      <button @click="removeToken(index)" class="bt-remove" style="margin-left: 5px; background: none; border: 0; color: #fff;"><span class="icon icon-icon_close"></span></button>
                                    </div>
                                  </div>
                                </div>

                              </fieldset>

                              <!--
                              <fieldset>
                                <h3>Amabassadeur</h3>
                                <p class="headline">Sélection d'un ambassadeur à qui attribuer la vente</p>

                                <form-autocomplete multiple="false" v-model="resource.person" :default="resource.person_id" :service="service"></form-autocomplete>

                              </fieldset>
                              -->

                            </tab>
                            <tab name="Conditions" class="vouchers-conditions">

                              <fieldset>
                                <h3>Conditions d'application</h3>
                                <p class="headline"></p>

                                <form-toggle label="Retreindre le nombre d'utilisation" v-model="resource.has_limitation"></form-toggle>

                                <div v-if="resource.has_limitation == 1">
                                  <form-text label="Limitation" v-model="resource.limit" :suffix="'utilisation(s) par code généré'"></form-text>
                                </div>

                                <form-select label="Application du rabais" multiple="false" v-model="resource.scope" :default="resource.scope" :options="scopes" hint="Le coupon s'applique au montant HT"></form-select>

                                <form-autocomplete label="Produits" multiple="true" v-model="resource.products" :default="resource.products" :service="products" v-if="resource.scope && resource.scope.id == 'product'"></form-autocomplete>
                                <form-autocomplete label="Categories" multiple="true" v-model="resource.categories" :default="resource.categories" :service="categories" v-if="resource.scope && resource.scope.id == 'product'"></form-autocomplete>
                                <form-autocomplete label="Marques" multiple="true" v-model="resource.brands" :default="resource.categories" :service="brands" v-if="resource.scope && resource.scope.id == 'product'"></form-autocomplete>

                                <group-line-2>
                                  <form-toggle label="Livraison gratuite" v-model="resource.has_free_delivery"></form-toggle>
                                  <form-toggle label="Cummulable" v-model="resource.is_cumulable"></form-toggle>
                                </group-line-2>

                              </fieldset>
                              <fieldset>
                                <h3>Conditions complémentaires</h3>
                                <p class="headline"></p>

                                <div v-for="(group, i) in conditions" v-if="conditions">
                                    <div class="group">
                                        <div v-for="(condition, x) in group">
                                            <table>
                                                <tr>
                                                    <td><select v-model="condition.type">
                                                        <option value="country">country</option>
                                                        <option value="total">total</option>
                                                        <option value="subtotal">subtotal</option>
                                                        <option value="totalItems">totalItems</option>
                                                    </select></td>
                                                    <td><select v-model="condition.operator">
                                                        <option value="egal">=</option>
                                                        <option value="greater_than">&gt;</option>
                                                        <option value="egal_greater_than">&gt;=</option>
                                                        <option value="less_than">&lt;</option>
                                                        <option value="egal_less_than">&lt;=</option>
                                                        <option value="not_egal">!=</option>
                                                        <option value="in">in</option>
                                                    </select></td>
                                                    <td><input type="text" v-model="condition.value"/></td>
                                                    <td><button @click="removeCondition(i, x)" class="bt-remove"><span class="icon icon-icon_close"></span></button></td>
                                                </tr>
                                            </table>
                                        </div>
                                        <button @click="renoveGroup(i)" class="btn">Remove group</button>
                                        <button @click="addToGroup(i)" class="btn">Add new condition</button>
                                        <span>ou</span>
                                    </div>
                                </div>
                                <button @click="addGroup()" class="btn">Add new group</button>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import VoucherService from './VoucherService.js';
    import PersonService from '../../person/PersonService.js';
    import ProductService from './../product/ProductService.js';
    import CategoryService from './../category/CategoryService.js';
    import BrandService from './../brand/BrandService.js';
    import Edit from '../../../layouts/Edit.vue';
    import ScopeService from "../../scope/ScopeService";

    export default {
        extends: Edit,
        data () {
            return {
                coucou: ['sum'],
                token: null,
                tokenQuantity: 10,
                service: null,
                products: null,
                categories: null,
                brands: null,
                conditions: [],
                scopes: [
                    {id:'subtotal', name: 'Sous-total TTC du panier'},
                    {id:'total', name: 'Total TTC du panier'},
                    {id:'product', name: 'Produits, catégories ou marques'}
                ],
                somme: "",
                action: 'manual',
                actionsSource: [
                  {id:'manual', name:'Manuel', description:'Création manuelle de codes promos'},
                  {id:'generator', name:'Automatique', description:'Génèration de codes uniques automatiquement'}
                ],
                limitations: [
                  {id:"0", name:"Illimité", description:"l'utilisation est illimitée"},
                  {id:"1", name:"Limité à un nombre d'utilisation", description:"l'utilisation est limitée à un nombre fixe"}
                ],
                discountType: 'percentage',
                discountTypes: [
                  {id:'percentage', name:'Pourcentage'},
                  {id:'sum', name:'Somme'}
                ],
            }
        },
        mounted: function(){

            this.service = PersonService;
            this.products = ProductService;
            this.categories = CategoryService;
            this.brands = BrandService;

            var countries = {}
            for (let item of this.$store.state.countries) {
                countries[this.resource.id] = item
            }

        },
        methods:{
            slugify: function(string){
              return string.toUpperCase()
                    .trim()
                    .replace(/[^\w\s-]/g, '')
                    .replace(/[\s_-]+/g, '-')
                    .replace(/^-+|-+$/g, '')
                    .replace(/ /g, '-');
            },
            selectDiscountType: function(type)
            {
              this.discountType = type;
              if( type == "sum" ){
                this.resource.is_number = true;
              }else{
                this.resource.is_number = false;
              }
              this.$forceUpdate()
            },
            selectIsGiftCard: function(bool)
            {
              this.resource.is_giftcard = bool;
              if( bool ){
                this.resource.is_number = true;
              }
              this.$forceUpdate()
            },
            removeToken: function(index){
              this.resource.tokens.splice(index, 1);
              this.$forceUpdate()
            },
            addToken: function(string){

              if( string === undefined || string === null ){
                return false;
              }

              let self = this;
              let tokens = string.split(',');

              for(let item of tokens){
                item = this.slugify(item);
                if( this.resource.tokens.indexOf(item) < 0 )
                {
                  this.resource.tokens.push(item);
                }
              }

              this.token = null;
              this.$forceUpdate()
            },
            generateCodes:function(){
              VoucherService.generate({'mask': this.resource.mask, 'quantity': this.tokenQuantity}).then(response => {
                let tokens = response.data
                for(let item of tokens){
                  if( this.resource.tokens.indexOf(item) < 0 )
                  {
                    this.resource.tokens.push(item);
                  }
                }
                this.$forceUpdate()
              });
            },
            resourceLoaded: function(){
                this.setTranslations(['name','description']);
                this.conditions = this.resource.conditions || [];
                this.resource.tokens = this.resource.tokens || [];
                this.resource.is_number = this.resource.is_number || false;
                this.resource.value = this.resource.value || 0;

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
                this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/

                this.discountType = this.resource.is_number ? "sum" : "percentage";
                this.action = this.resource.mask ? "generator" : "manual";

                this.initialize()
            },
            getResource: function(){
                return VoucherService
            },
            beforeUpdate: function(Resource){
                this.updateVars();
                return true;
            },
            // CONDITIONS
            updateVars: function(){
                let tmp_conditions = [];
                for (var i=0 ; i<this.conditions.length ; i++) {
                    var tmp_sub_conditions = [];
                    for (var x=0 ; x<this.conditions[i].length ; x++) {
                        var obj = {};
                        obj.type = this.conditions[i][x].type;
                        obj.operator = this.conditions[i][x].operator;
                        obj.value = this.conditions[i][x].value;
                        tmp_sub_conditions.push(obj);
                    }
                    tmp_conditions.push(tmp_sub_conditions);
                }
                this.conditions = tmp_conditions;
                this.resource.conditions = this.conditions;
                console.log(this.conditions);
            },
            addGroup: function(){
                this.conditions.push([]);
                this.updateVars();
            },
            addToGroup: function(index){
                this.conditions[index].push({
                    type: "country",
                    operator: "egal",
                    value: ""
                });
                this.updateVars();
            },
            renoveGroup: function(index){
                this.conditions.splice(index,1);
                this.updateVars();
            },
            removeCondition: function(index, index2){
                this.conditions[index].splice(index2,1);
                this.updateVars();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/voucher/Edit.vue